// Redirect /settings → /settings/general so bare visits always land on a
// populated section without a blank Outlet.
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_admin/settings/")({
  beforeLoad: () => {
    throw redirect({ to: "/settings/general", replace: true });
  },
  component: () => null,
});
